import {
  MyApprovalRequestsTableFieldsFragment,
  Maybe,
  ApprovalRequestStatus,
  AbsenceApprovalStatus,
} from '../../../__generated__/graphql';
import { mapApprover } from '../../Absences/MyAbsences/mappings';
import { Approver } from '../../Absences/MyAbsences/MyAbsenceFilters/types';

export type ApprovalRequestTableItem = {
  id: string;
  name: string;
  employee: {
    id: string;
    name: string;
    avatarUrl: Maybe<string>;
  };
  approvalStatus: ApprovalRequestStatus;
  actionDatetime: Maybe<string>;
  relatedRecordId: string;
  relatedRecordApiName: string;
  relatedRecordName: string;
  relatedRecordObjectName: string;
  createdDate: string;
  approverComment: Maybe<string>;
  approver?: Maybe<Approver>;
  lastModifiedDate?: string;
  actions: string;
  //TODO:: temp solution
  absence?: Maybe<{
    Id: string;
    flair__Approval_Status__c: AbsenceApprovalStatus;
  }>;
  startDate: string;
};

export const mapApprovalRequests = (
  src: ReadonlyArray<MyApprovalRequestsTableFieldsFragment>,
): ApprovalRequestTableItem[] => {
  return src
    .map((item) => ({
      id: item.Id,
      name: item.Name,
      employee: {
        id: item.recordEmployee?.Id ?? '',
        name: item.recordEmployee?.Name ?? '',
        avatarUrl: item.recordEmployee?.avatar?.url ?? null,
      },
      approvalStatus: item.flair__Approval_Status__c,
      actionDatetime: item.flair__Action_Datetime__c,
      relatedRecordId: item.flair__Related_Id__c,
      relatedRecordApiName: item.flair__Related_Object_Name__c,
      relatedRecordName: item.relatedRecordName ?? '',
      relatedRecordObjectName: item.relatedRecordObjectName,
      createdDate: item.CreatedDate,
      approverComment: item.flair__Approver_Comment__c,
      approver: item.approver ? mapApprover(item.approver) : null,
      lastModifiedDate: item.LastModifiedDate,
      actions: '',
      //TODO:: temp solution
      absence: item.absence
        ? {
            Id: item.absence.Id,
            flair__Approval_Status__c: item.absence.flair__Approval_Status__c,
          }
        : null,
      // Start date is a workarond for now to sort
      startDate: item.absence?.flair__Start_Date__c ?? item.CreatedDate,
    }))
    .sort((a, b) => {
      return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
    });
};
